"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Dropdown = require("./Dropdown.styles");
var _excluded = ["children"];
/**
 * Dropdown is a generic Dialog for contextual content. It is similar to the Popover
 * component, but it doesn't include an arrow nor a close button.
 *
 * Dropdown makes no assumption about the content. Make sure you set appropriate height and width
 * on your content. For a dropdown that focuses on a list of actions, see the Menu component.
 *
 * @extends Dialog
 * @related [`Menu`, `Popover`]
 * @since 7.28.0
 */
var Dropdown = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var children = props.children,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var content = children;
  if (typeof children === 'function') {
    content = children(props);
  }
  return /*#__PURE__*/_react.default.createElement(_Dropdown.StyledDropdown, (0, _extends2.default)({
    innerRef: forwardedRef
  }, rest, {
    shouldTakeFocus: false
  }), content);
});
exports.Dropdown = Dropdown;
Dropdown.displayName = 'Dropdown';
Dropdown.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The dropdown content as a node or a render function.
   *
   * When passing a render function, you get access to the props as the only
   * argument. You can use the `onClose` prop in your render function to signal that the dropdown
   * should be closed.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * @ignore
   */
  closeButton: _propTypes.default.node,
  /**
   * @ignore
   */
  renderCloseButton: _propTypes.default.node,
  /**
   * Inherited from the `Dialog` component.
   */
  shouldCloseOnESCKeyPress: _propTypes.default.bool,
  /**
   * Inherited from the `Dialog` component.
   */
  shouldCloseOnOutsideClick: _propTypes.default.bool,
  /**
   * Always false, use `Popper` `shouldFocusTriggered` instead.
   *
   * Inherited from the `Dialog` component.
   */
  shouldTakeFocus: _propTypes.default.bool
} : {};
Dropdown.defaultProps = {
  closeButton: null,
  renderCloseButton: null,
  shouldCloseOnESCKeyPress: true,
  shouldCloseOnOutsideClick: true,
  shouldTakeFocus: false
};